module.exports = __webpack_public_path__ + "bd9cfdebdcd9e643cd486f54347c4922.MP3";